import React from 'react';
import { useSelector } from 'react-redux';
import VehiclesTableRow from './VehiclesTableRow';
import VehiclesAttributeRow from './VehiclesAttributeRow';
import VehiclesDetailsButtonRow from './VehiclesDetailsButtonRow';
import Navigator from './Navigator/Navigator';

const CompareTable = () => {
	const vehicleCount = useSelector((state) => state.vehicles.length);
	return (
		<table className="table mx-auto" data-col-count={`${vehicleCount}`}>
			<tbody>
				<VehiclesTableRow />
				<Navigator />
				<VehiclesAttributeRow />
				<VehiclesDetailsButtonRow />
			</tbody>
		</table>
	);
};

export default CompareTable;
